import { getAd } from "api/ad";
import { call, put } from "redux-saga/effects";
import { resetApiError, riseError } from "store/features/general";
import { fetchAd } from "./ad.actions";
import { Ad } from "./interfaces";

export function* fetchAdSaga(headers: HeadersInit, action: ReturnType<typeof fetchAd.request>): Generator {
    try {
        const ad = (yield call(getAd, headers, action.payload)) as Ad;
        yield put(fetchAd.success(ad));
    } catch (err) {
        if (err.status) {
            yield put(fetchAd.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
